export interface DeductionSplitDisplayChipProps {
  axis: string;
  label: string | null;
  value: string;
}

export interface DeductionSplitDisplayProps {
  separator: string | null;
  chips: DeductionSplitDisplayChipProps[];
  headerText: string | null;
}

export class DeductionSplitDisplayChip {
  private readonly _axis: string;
  private readonly _label: string | null;
  private readonly _value: string;

  constructor(props: DeductionSplitDisplayChipProps) {
    this._axis = props.axis;
    this._label = props.label ?? null;
    this._value = props.value;
  }

  public get axis(): string {
    return this._axis;
  }

  public get label(): string | null {
    return this._label;
  }

  public get value(): string {
    return this._value;
  }
}

export class DeductionSplitDisplay {
  private readonly _separator: string | null;
  private readonly _chips: DeductionSplitDisplayChipProps[];
  private readonly _headerText: string | null;

  constructor(props: DeductionSplitDisplayProps) {
    this._separator = props.separator ?? null;
    this._chips = props.chips ?? [];
    this._headerText = props.headerText ?? null;
  }

  public get separator(): string | null {
    return this._separator;
  }

  public get chips(): DeductionSplitDisplayChip[] {
    return this._chips.map(chip => new DeductionSplitDisplayChip(chip));
  }

  public get headerText(): string | null {
    return this._headerText;
  }
}
